/**
 * tolling-api v2
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActivityPlazaResponseDto } from './activityPlazaResponse';
import { ActivityLocationResponseDto } from './activityLocationResponse';
import { ActivityFacilityResponseDto } from './activityFacilityResponse';
import { ActivityVehicleResponseDto } from './activityVehicleResponse';
import { ActivityPromotionResponseDto } from './activityPromotionResponse';
import { ActivityCorrectionResponseDto } from './activityCorrectionResponse';

export interface ActivityResponseDto {
    id?: string;
    paymentStatus?: ActivityResponseDto.PaymentStatusEnum;
    dotState?: string;
    exitDateTime?: string;
    vehicle?: ActivityVehicleResponseDto;
    facility?: ActivityFacilityResponseDto;
    entry?: ActivityPlazaResponseDto;
    exit?: ActivityPlazaResponseDto;
    location?: string;
    activityLocation?: ActivityLocationResponseDto;
    vehicleType?: string;
    currency?: string;
    amount?: number;
    fees?: number;
    promotions?: Array<ActivityPromotionResponseDto>;
    corrections?: Array<ActivityCorrectionResponseDto>;
    subTotalAmount?: number;
    totalAmount?: number;
    cancellation?: boolean;
    correction?: boolean;
}
export namespace ActivityResponseDto {
    export const PaymentStatusEnum = {
        Pending: 'PENDING',
        Paid: 'PAID',
        Corrected: 'CORRECTED',
        Error: 'ERROR',
    } as const;
    export type PaymentStatusEnum = (typeof PaymentStatusEnum)[keyof typeof PaymentStatusEnum];
}
